// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  background: white;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
.wrapper::-webkit-scrollbar {
  display: none;
}
@media (max-width: 992px) {
  .wrapper {
    justify-content: flex-start;
  }
}

.slide {
  transform: translateX(20px);
}

.line-dotted-block {
  min-width: 20px;
  height: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .line-dotted-block {
    height: 112px;
    min-width: 50px;
  }
  .line-dotted-block ion-img {
    width: 23px;
  }
}

.category-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
  height: 100%;
}
@media (min-width: 991px) {
  .category-wrapper {
    min-width: -moz-fit-content;
    min-width: fit-content;
    width: 120px;
  }
}
.category-wrapper .category-name {
  padding-top: 10px;
  font-size: 12px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0px;
  font-weight: 100;
  margin-bottom: 0px;
  width: 60px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: #979797;
}
@media (min-width: 991px) {
  .category-wrapper .category-name {
    width: 100px;
    font-size: 22px;
  }
  .category-wrapper .category-name.selected {
    color: var(--text-color);
    transition: ease-in-out 0.5s;
  }
}
.category-wrapper.selected {
  transition: 200ms linear;
}
.category-wrapper .chip-wrapper {
  width: 70px;
  display: flex;
  justify-content: center;
}
.category-wrapper ion-chip {
  opacity: 1;
  border-radius: 50%;
  padding: 5px;
  background: white;
  text-transform: capitalize;
  flex: 0 0 auto;
  height: 60px;
  width: 60px;
  margin: 0px;
  padding: 0px;
  position: relative;
}
@media (min-width: 991px) {
  .category-wrapper ion-chip {
    height: 60px;
    width: 60px;
  }
}
.category-wrapper ion-chip .category-image {
  width: 80%;
  margin: 0 auto;
}
.category-wrapper ion-chip .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
  background: url("/assets/losteria/border-dotted_black.svg") no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .category-wrapper ion-chip .border-dotted {
    height: 55px;
    width: 55px;
  }
}

@media (max-width: 992px) {
  .selected {
    width: 100px !important;
  }
}
.selected ion-chip {
  opacity: 1;
  background: var(--ion-color-primary);
  width: 70px;
  height: 70px;
}
.selected ion-chip ion-img {
  filter: contrast(1.2) invert(1);
}
.selected ion-chip .border-dotted {
  width: 65px;
  height: 65px;
}
@media (max-width: 992px) {
  .selected .line-dotted-block {
    transform: translateX(8px);
  }
}
.selected .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
  background: url("/assets/losteria/border-dotted.svg") no-repeat center center/100% 100% !important;
}
@media (min-width: 991px) {
  .selected .border-dotted {
    height: 55px;
    width: 55px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/scrolling-categoris/scrolling-categories.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AADD;AAEC;EACC,aAAA;AAAF;ACHE;EDLF;IAYE,2BAAA;EAAA;AACF;;AAGA;EACC,2BAAA;AAAD;;AAGA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAD;AC1BE;EDqBF;IAOE,aAAA;IACA,eAAA;EAEA;EADA;IACC,WAAA;EAGD;AACF;;AAAA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,YAAA;AAGD;AC3CE;EDmCF;IAOE,2BAAA;IAAA,sBAAA;IACA,YAAA;EAKA;AACF;AAJC;EACC,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;AAMF;AClEE;ED6CD;IAiBE,YAAA;IACA,eAAA;EAQD;EAPC;IACC,wBAAA;IACA,4BAAA;EASF;AACF;AACC;EACC,wBAAA;AACF;AAEC;EACC,WAAA;EACA,aAAA;EACA,uBAAA;AAAF;AAGC;EACC,UAAA;EAEA,kBAAA;EACA,YAAA;EACA,iBAAA;EAGA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAJF;ACjGE;EDuFD;IAiBE,YAAA;IACA,WAAA;EAHD;AACF;AAIE;EACC,UAAA;EACA,cAAA;AAFH;AAIE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,6FAAA;AAFH;ACpHE;ED+GA;IASE,YAAA;IACA,WAAA;EAAF;AACF;;ACpHE;EDwHF;IAEE,uBAAA;EADA;AACF;AAEC;EACC,UAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAAF;AAEE;EACC,+BAAA;AAAH;AAEE;EACC,WAAA;EACA,YAAA;AAAH;ACvIE;ED2ID;IAEE,0BAAA;EAFD;AACF;AAMC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kGAAA;AAJF;AC3JE;EDwJD;IASE,YAAA;IACA,WAAA;EAFD;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tbackground: white;\n\tmargin: 0 auto;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\toverflow: auto;\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t@include mobile {\n\t\tjustify-content: flex-start;\n\t}\n}\n\n.slide {\n\ttransform: translateX(20px);\n}\n\n.line-dotted-block {\n\tmin-width: 20px;\n\theight: 63px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include desktop {\n\t\theight: 112px;\n\t\tmin-width: 50px;\n\t\tion-img {\n\t\t\twidth: 23px;\n\t\t}\n\t}\n}\n.category-wrapper {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tmin-width: fit-content;\n\theight: 100%;\n\t@include desktop {\n\t\tmin-width: fit-content;\n\t\twidth: 120px;\n\t}\n\t.category-name {\n\t\tpadding-top: 10px;\n\t\tfont-size: 12px;\n\t\tword-break: break-word;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmargin-top: 0px;\n\t\tfont-weight: 100;\n\t\tmargin-bottom: 0px;\n\t\twidth: 60px;\n\t\ttext-align: center;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: #979797;\n\t\t@include desktop {\n\t\t\twidth: 100px;\n\t\t\tfont-size: 22px;\n\t\t\t&.selected {\n\t\t\t\tcolor: var(--text-color);\n\t\t\t\ttransition: ease-in-out 0.5s;\n\t\t\t}\n\t\t}\n\t}\n\t// &:first-child {\n\t// \tmargin-left: 12px;\n\t// }\n\n\t// &:last-child {\n\t// \tmin-width: 100% !important;\n\t// }\n\t&.selected {\n\t\ttransition: 200ms linear;\n\t}\n\n\t.chip-wrapper {\n\t\twidth: 70px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\tion-chip {\n\t\topacity: 1;\n\n\t\tborder-radius: 50%;\n\t\tpadding: 5px;\n\t\tbackground: white;\n\n\t\t// transition: color 200ms linear, background 200ms linear;\n\t\ttext-transform: capitalize;\n\t\tflex: 0 0 auto;\n\t\theight: 60px;\n\t\twidth: 60px;\n\t\tmargin: 0px;\n\t\tpadding: 0px;\n\t\tposition: relative;\n\n\t\t@include desktop {\n\t\t\theight: 60px;\n\t\t\twidth: 60px;\n\t\t}\n\t\t.category-image {\n\t\t\twidth: 80%;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t\t.border-dotted {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\twidth: 58px;\n\t\t\theight: 58px;\n\t\t\tbackground: url('/assets/losteria/border-dotted_black.svg') no-repeat center center/ 100% 100%;\n\t\t\t@include desktop {\n\t\t\t\theight: 55px;\n\t\t\t\twidth: 55px;\n\t\t\t}\n\t\t}\n\t}\n}\n.selected {\n\t@include mobile {\n\t\twidth: 100px !important;\n\t}\n\tion-chip {\n\t\topacity: 1;\n\t\tbackground: var(--ion-color-primary);\n\t\twidth: 70px;\n\t\theight: 70px;\n\n\t\tion-img {\n\t\t\tfilter: contrast(1.2) invert(1);\n\t\t}\n\t\t.border-dotted {\n\t\t\twidth: 65px;\n\t\t\theight: 65px;\n\t\t}\n\t}\n\n\t.line-dotted-block {\n\t\t@include mobile {\n\t\t\ttransform: translateX(8px);\n\t\t}\n\n\t}\n\n\t.border-dotted {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 58px;\n\t\theight: 58px;\n\t\tbackground: url('/assets/losteria/border-dotted.svg') no-repeat center center/ 100% 100% !important;\n\t\t@include desktop {\n\t\t\theight: 55px;\n\t\t\twidth: 55px;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
